import React, { FC } from 'react'
import { Datagrid, Filter, FilterProps, List, ListProps, SearchInput, TextField } from 'react-admin'
import { Helmet } from 'react-helmet'
import { WEB_APP_TITLE } from 'src/constants'
import RouteBreadcrumbs from '../../components/RouteBreadcrumbs'

const SizeFilter: FC<Omit<FilterProps, 'children'>> = (props) => (
  <Filter {...props}>
    <SearchInput source="label,code" alwaysOn />
  </Filter>
)

const SizeList: FC<ListProps> = (props) => {
  return (
    <>
      <Helmet title={`${WEB_APP_TITLE} - Sizes`} />
      <RouteBreadcrumbs {...props} />
      <List
        {...props}
        perPage={25}
        sort={{ field: 'label', order: 'ASC' }}
        filters={<SizeFilter />}
        bulkActionButtons={false}
      >
        <Datagrid rowClick="edit">
          <TextField source="label" />
          <TextField source="code" />
          <TextField source="size_values_aggregate.aggregate.count" label="Items" align="center" />
        </Datagrid>
      </List>
    </>
  )
}

export default SizeList
